const vwoStorageKeyPrefix = "__vwo__"

const storageKeys = {
  APPLIED_VOUCHER: "voucher_applied",
  AUTH_JWT: "__formel_token__",
  BANNER_DISMISSED: "cms_banner-dismissed",
  TERMS_AND_CONDITIONS_DISMISSED: "terms_and_conditions-dismissed",
  BANNERS_HIDDEN: "hiddenBanners",
  DISABLE_INITIAL_TREATMENT_PLAN_REDIRECT:
    "DISABLE_INITIAL_TREATMENT_PLAN_REDIRECT",
  FIRSTNAME: "firstName",
  HOME_INTRO_DISMISSED: "home.intro-dismissed",
  INITIAL_ANSWERS: "initialQAnswers",
  INITIAL_QUESTIONS: "initialQQuestions",
  INITIAL_Q_TREATMENT_GOAL_KEY: "initial_q_treatment_goal",
  NPS_DISMISSED: "dontShowNps",
  ONBOARDING_SURVEY_DISMISSED: "dontShowOnboardingSurvey",
  REPURCHASE_DIALOG_HIDDEN: "repurchase-dialog-hidden",
  USER_DETAILS: "userDetails",
  TRACKING: "__formel_tracking__",
  TRACKING_ALL: "__formel_tracking_all__",
  TRACKING_ORIGINAL_SOURCE: "__formel_tracking_original_source__",
  USER_CREATED_AT: "user_created_at",
  VOUCHER_URL: "voucher_code",
  TEMP_TOKEN: "tempToken",
  CHAT_SCROLL_HEIGHT: "chatScrollHeight",
  TEMP_LOCAL_STORAGE_FILES: "tempLocalStorageFiles",
  VWO_INITIAL_QUESTIONNARE_ID: "INITIAL_QUESTIONNARE_ID",
  VWO_TOFU_INITIAL_QUESTIONNARE_ID: `${vwoStorageKeyPrefix}tofuInitialQuestionnareId`,
  VWO_INITIAL_QUESTIONNARE_PROVIDER: "INITIAL_QUESTIONNARE_PROVIDER",
  VWO_QUESTIONNARE_PROVIDER: "QUESTIONNARE_PROVIDER",
  VWO_PLAN_SELECTION_TEST_RELEASE: `${vwoStorageKeyPrefix}planSelectionTestRelease`,
  VWO_SIDE_EFFECTS_SELF_SERVICE: `${vwoStorageKeyPrefix}side_effects_self_service`,
  VWO_TEST_PRESET_TYPE: `${vwoStorageKeyPrefix}testPresetType`,
  VWO_THEME_VARIANT: `${vwoStorageKeyPrefix}themeVariant`,
  VWO_TREATMENT_INDICATION: "TREATMENT_INDICATION",
  VWO_TREATMENT_INGREDIENTS: "TREATMENT_INGREDIENTS",
  VWO_FORMULA_SEGMENTS: "FORMULA_SEGMENTS",
  TOFU_JWT: "__tofu__jwt",
  TOFU_PAYMENT_GATEWAY: "__tofu__paymentGateway",
  TOFU_PAYMENT_SUCCEEDED: "__tofu__paymentSucceeded",
  TOFU_PHOTOS_UPLOAD_SUCCESS: "TOFU_PHOTOS_UPLOAD_SUCCESS",
  VWO_SUBSCRIPTION_TYPE: "SUBSCRIPTION_TYPE",
  VWO_SUBSCRIPTION_CYCLES: "SUBSCRIPTION_CYCLES",
  VWO_AVERAGE_NPS: `${vwoStorageKeyPrefix}AVERAGE_NPS`,
  VWO_USER_AYD_COUNT: `${vwoStorageKeyPrefix}USER_AYD_COUNT`,
  VWO_CONFIRMED_DIAGNOSES: "CONFIRMED_DIAGNOSES",
  VWO_MEDICAL_CREAM_NAMES: "MEDICAL_CREAM_NAMES",
  // VWO_NEW_CHAT: `${vwoStorageKeyPrefix}new_chat_look_and_feel`,
  // VWO_NEW_CHAT_ELIGIBLE: `${vwoStorageKeyPrefix}new_chat_look_and_feel_eligible`,
  VWO_JOURNEY_STATUS: `${vwoStorageKeyPrefix}journey_status`,
  JOURNEY_STATUS_MEDICAL_DATA_EXPIRE_AFTER_DAYS:
    "journeyStatus.medicalDataExpireAfterDays",
  JOURNEY_STATUS_NUMBER_OF_HOURS_ORDER_IS_IN_DELIVERY:
    "journeyStatus.numberOfHoursOrderIsInDelivery",
  TOFU_TO_CORE_MAIN_PRESET_ID: "tofuToCoreMainPreset",
  BVDD_PRAXIS: "bvddPraxis",
  SKINSET_ANNOUNCEMENT_SHEET_DISMISSED: "dontShowSkinSetAnnouncementSheet",
  VWO_NPS_LONG_TERM_ELIGIBILITY: `${vwoStorageKeyPrefix}nps_long_term_eligibility`,
  VWO_CHURN_PREVENTION_MESSAGE_DOCTOR_ELIGIBILITY: `${vwoStorageKeyPrefix}churn_prevention_message_doctor_eligibility`,
  INITIAL_TRACKING_EVENT_SENT: "__initial_tracking_event_sent__",
  VWO_PERSONALIZED_TREATMENT_ELIGIBILITY: `${vwoStorageKeyPrefix}personalized_treatment_eligibility`,
  CUSTOMER_IO_IDENTIFY_USER_ID: "__customer_io_identify_user_id__",
  VWO_IMPROVED_PATIENT_FEEDBACK_ELIGIBILITY: `${vwoStorageKeyPrefix}improved_patient_feedback_eligibility`,
  INITIAL_FACEBOOK_EXTERNAL_ID: "__initial_facebook_external_id",
  INITIAL_Q_TREATMENT_GOAL_BEFORE_SIGNUP_KEY:
    "initial_q_treatment_goal_before_signup",
}

// TODO: [FS-6060] add cookie support
const storageTypes = {
  LOCAL: "localStorage",
  SESSION: "sessionStorage",
}

const clientOnly = (action) =>
  typeof window === "undefined"
    ? () => {
        // no-op
      }
    : action

const getStorageKeys = () => storageKeys

const getStorageTypes = () => storageTypes

const getItem = clientOnly(({ id, storageType = storageTypes.LOCAL }) => {
  const data =
    storageType instanceof Array
      ? window[
          storageType.find((storage) => window[storage].getItem(id))
        ]?.getItem(id)
      : window[storageType].getItem(id)

  try {
    return JSON.parse(data)
  } catch {
    return data
  }
})

const setItem = clientOnly(
  ({ id, data: payload, storageType = storageTypes.LOCAL }) => {
    const data = typeof payload === "string" ? payload : JSON.stringify(payload)

    storageType instanceof Array
      ? storageType.forEach((storage) => window[storage].setItem(id, data))
      : window[storageType].setItem(id, data)
  }
)

const removeItem = clientOnly(({ id, storageType = storageTypes.LOCAL }) => {
  storageType instanceof Array
    ? storageType.forEach((storage) => window[storage].removeItem(id))
    : window[storageType].removeItem(id)
})

const removeAll = clientOnly(({ storageType = storageTypes.LOCAL }) => {
  Object.values(storageKeys).forEach((id) => removeItem({ id, storageType }))
})

export {
  getStorageTypes,
  getStorageKeys,
  getItem,
  setItem,
  removeItem,
  removeAll,
  vwoStorageKeyPrefix,
}
